import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasPopupSettingsComponent } from './canvas-popup-settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [CanvasPopupSettingsComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [CanvasPopupSettingsComponent],
})
export class CanvasPopupSettingsModule {}
